import { FileUpload } from '@mui/icons-material';
import { Button, Input, Stack, TablePagination } from '@mui/material';
import { DownloadButton } from 'components';
import { AddButton } from 'components/AddButton';
import { t } from 'i18next';
import { ReactNode } from 'react';
import { capitalizeFirstLetterEveryword } from 'shared/stringFunctions';
import { TXT_UPLOAD_FILE } from '../../../../../shared/translations';
import { usePaginationBarStyles } from './paginationBarStyles';

export interface PaginationBarProps {
  rowsPerPageOptions?: (
    | number
    | {
        value: number;
        label: string;
      }
  )[];
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
  onRowsPerPageChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  className?: string;
  children?: ReactNode;
  openAddEditor?: () => void;
  disabled?: boolean;
  onDownload?: () => void;
  onUpload?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PaginationBar = (props: PaginationBarProps) => {
  const { children, openAddEditor, onDownload, onUpload, ...rest } = props;
  const classes = usePaginationBarStyles();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <div style={{ display: 'flex', gap: '10px' }}>
        {openAddEditor ? <AddButton disabled={props.disabled} openAddEditor={openAddEditor}></AddButton> : null}
        {onDownload ? <DownloadButton disabled={props.disabled} onDownload={onDownload}></DownloadButton> : null}
        {onUpload ? (
          <Button
            disabled={props.disabled}
            component="label"
            variant="contained"
            color="primary"
            startIcon={<FileUpload />}
          >
            <Input
              id="state-file-upload"
              type="file"
              style={{ display: 'none' }}
              onChange={onUpload}
              onClick={(e: React.MouseEvent<HTMLInputElement>) => ((e?.target as HTMLInputElement).value = '')}
            />
            {capitalizeFirstLetterEveryword(t(TXT_UPLOAD_FILE))}
          </Button>
        ) : null}
      </div>
      <div>{children}</div>
      <TablePagination
        {...rest}
        component="div"
        rowsPerPageOptions={props.rowsPerPageOptions || [5, 10, 25, 100]}
        className={props.className || classes.pagingBar}
      />
    </Stack>
  );
};
